import { useRefetchForms } from './useRefetchForms'
import { useResolveAmendments } from './useResolveAmendments'

export const useMarkAmendmentsAsResolved = ({ requestId }: { requestId: string }) => {
  const { mutateAsync: resolveAmendments } = useResolveAmendments({ requestId })
  const refetchForms = useRefetchForms()

  const handleMarkAmendmentsAsResolved = async ({
    commentIds,
    requestFormId,
  }: {
    requestFormId: string
    commentIds: string[]
  }) => {
    await resolveAmendments({ commentIds, requestFormId })
    await refetchForms({ requestId, requestFormId })
  }
  return handleMarkAmendmentsAsResolved
}
